module.exports = __webpack_public_path__ + "img/personal_icon_collection@2x.a326ef6e.png";